import { render, staticRenderFns } from "./QuotationProposalCafezalCoverage.vue?vue&type=template&id=536a89c3"
import script from "./QuotationProposalCafezalCoverage.vue?vue&type=script&lang=js"
export * from "./QuotationProposalCafezalCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports